import styled from 'styled-components';
import { styled as muiStyled } from '@mui/material/styles';
import Box from "@mui/material/Box";
import withColors from '../../../../styles/withColors';
import { MediaQuerys } from '../../../../styles/GlobalStyle';
import { useColors } from "../../../../Context/ColorsContext"

const { mobile, tablet, desktop } = MediaQuerys;

const ContainerStyle = styled.div`
  width:100%;
  height:100%;
  display:flex;
  justify-content:center;
  align-items:center;
  padding-bottom:10px;
  /*
  background: ${({ colors }) => colors.red};
  */
  ${mobile} {
    flex-direction:column;
    height:max-content;
    padding:12px 16px;
  }
`

const FormStyle = styled.div`
  display:flex;
  flex-direction:column;
  align-items:center;
  ${mobile} {
    width:100%;
    padding:0 1em;
  }
`

const TitleStyle = styled.p`
  font-size:24px;
  font-weight: bold;
  text-align:center;
  max-width: 600px;
  color:${({ colors }) => colors.blackFont};
  ${mobile} {
    font-size:20px;
  }
`

const SectionRowStyle = styled.section`
  display:flex;
  width:100%;
  align-items:center;
  text-align:left;
  justify-content:center;
  ${mobile} {
    flex-direction:column;
    align-items: center;
  }
`

const SectionInputStyle = styled.section`
  display:flex;
  flex-direction:column;
  width:350px;
  margin-left: ${props => (props.second ? '24px' : '')};
  ${mobile} {
    width:100%;
    margin-top: ${props => (props.bottom ? '12px' : '')};
    margin-left:0;
  }
`

const LabelStyle = styled.label`
  padding-bottom:4px;
  padding-left:4px;
  color:${({ colors }) => colors.blackFont};
  ${tablet} {
    font-size: 12px;
  }
`

const ContainerInputStyle = styled.div`
  background: ${({ colors }) => colors.gray};
  border-bottom:2px solid ${({ colors }) => colors.gray};
  height:32px;
  padding:0 8px;
  display:flex;
  align-items:center;
  border-radius:5px;
`

const FigureStyle = styled.figure`
  display:flex;
  justify-content:center;
  margin-left: ${props => (props.marginLeft ? "8px" : "")};
  margin-top: ${props => (props.marginTop ? "4px" : "")};
  margin-bottom: ${props => (props.marginBottom ? "4px" : "")};
  margin-right: ${props => (props.marginRight ? "12px" : "")};
`

const InputStyle = styled.input`
  background: ${({ colors }) => colors.gray};
  width:100%;
  color:${({ colors }) => colors.blackFont};
  font-size:16px;
  ${desktop} {
    font-size:14px;
  }
  &::-webkit-inner-spin-button, ::-webkit-outer-spin-button  {
    -webkit-appearance: none;
    margin: 0;
  }
  -moz-appearance:textfield;
`

const SpanStyle = styled.span`
  width: 100%;
  text-align: center;
  color: ${({ colors }) => colors.red};
  font-size: 14px;
  padding-top:4px;
  padding-left:4px;
  min-height:20px;
  &.activate {
    visibility:visible;
    transition:all .3s ease;
  }
  &.closed {
    visibility:hidden;
    transition:all .3s ease-in-out;
  }
`

const SpanLinkStyle = styled.p`
  width: 100%;
  text-align: center;
  color: ${({ colors }) => colors.blackFont};
  text-decoration: underline;
  padding-top:4px;
  padding-left:4px;
  height:20px;
  font-size: 14px;
  &.activate {
    visibility:visible;
    transition:all .3s ease;
  }
  &.closed {
    visibility:hidden;
    transition:all .3s ease-in-out;
  }
`

const SectionBtnStyle = styled.section`
  text-align: center;
  padding:8px 0 16px;
  width:100%;
  display: ${props => (props.double ? 'block' : 'flex')};
  justify-content: center;
  ${mobile} {
    padding:12px 0 16px;
  }
`

const BtnSubmitStyle = ({ colors, disabled, ...props }) => (
  <button
    {...props}
    style={{
      color: colors.white,
      background: disabled ? colors.gray : colors.buttonActionColor,
      cursor: disabled ? 'not-allowed' : 'pointer',
      padding: '.5em 2em',
      borderRadius: '5px',
      display: 'inline-block',
      justifyContent: 'center',
      transition: 'all .3s ease-in-out',
      width: '50%',
      '&:hover': {
        transition: 'all .3s ease',
        opacity: '.8',
      },
      '&:active': {
        transition: 'all .3s ease',
        opacity: '1',
      },
    }}
  />
);

const BoxModalStyle = styled(Box)(() => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
}))

const CustomLabel = styled('label')(() => {
  const { colors } = useColors();
  return {
    paddingBottom: '4px',
    paddingLeft: '4px',
    color: colors.blackFont,
    [desktop]: {
      fontSize: '14px',
    }
  }
})

export const Subtitle = styled('span')(() => {
  const { colors } = useColors();
  return {
      color: colors.blackFont,
      fontSize: '16px',
      paddingBottom: '20px',
      maxWidth: '200px',
      [mobile]: {
        paddingBottom: '24px',
      }
  }
})

export const ImageContainer = styled('div')(() => {
  return {
      width: '250px',
      height: '170px', 
      overflow: 'hidden',
      display: 'flex',
      alignItems: 'center',
  }
})


export const Container = withColors(ContainerStyle);
export const Form = withColors(FormStyle);
export const Title = withColors(TitleStyle);
export const SectionRow = withColors(SectionRowStyle);
export const SectionInput = withColors(SectionInputStyle);
export const Label = withColors(LabelStyle);
export const ContainerInput = withColors(ContainerInputStyle);
export const Figure = withColors(FigureStyle);
export const Input = withColors(InputStyle);
export const Span = withColors(SpanStyle);
export const SpanLink = withColors(SpanLinkStyle);
export const SectionBtn = withColors(SectionBtnStyle);
export const BtnSubmit = withColors(BtnSubmitStyle);
export const BoxModal = withColors(BoxModalStyle);
export const LabelCustom = withColors(CustomLabel);

export const MicrosoftContainer = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 10px;
  width: 350px;
  ${mobile} {
    width: 100%;
  }
`

export const ModalContainer = muiStyled('div')(() => ({
  display: 'flex',
  width: '100%',
  minWidth: '500px',
  height: '100%',
  flexDirection: 'column',
  [mobile]: {
    minWidth: '380px',
  }
}))

export const ModalHeader = muiStyled('div')(() => {
  const { colors } = useColors();
  return {
    display: 'flex',
    background: colors.white,
    color: colors.detailTextColor,
    width: '100%',
    height: 'fit-content',
    borderRadius: '10px 10px 0 0',
    padding: '16px',
    textTransform: 'uppercase',
    fontWeight: 600,
    [desktop]: {
      fontSize: '0.85rem',
    },
  }
})

export const ModalBody = muiStyled('div')(() => {
  const { colors } = useColors();
  return {
    display: 'flex',
    flexDirection: 'column',
    flex: '1',
    width: '100%',
    background: colors.white,
    padding: '16px',
  }
})

export const ModalFooter = muiStyled('div')(() => {
  const { colors } = useColors();
  return {
    display: 'flex',
    background: colors.white,
    width: '100%',
    height: 'fit-content',
    borderRadius: '0 0 10px 10px',
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: '8px 16px',
    margin: 'auto',
    gap: '8px',
  }
})
